/** 
 * This Mixin provides the structures needed to scroll a slice over a list
*/

export {  Scrollable  };

var Scrollable = {

	data: function() {
		return {
			touchCord: [0, 0],

			// current positional slice
			slice: 0,
			// the maximal slice
			maxSlice: 0,
			// the scroll by amount
			scrollBy: 6,

			// autoamtic scrolling when mouse button is hold down
			autoscrollHandle: null,
			autoscrollDir: 1,		
		};
	},

	methods: {

		// Register the start coordinates of a touch event
		touchStartScroll: function(event) {
			this.touchCord = [
				event.changedTouches [0].pageX,
				event.changedTouches [0].pageY
			];
		},

		// Register the end coordinates of a touch event
		touchEndScroll: function(event) {
			let endpoint = [
				event.changedTouches [0].pageX,
				event.changedTouches [0].pageY
			];
			let deltaY = endpoint [1] - this.touchCord [1];
			let deltaX = endpoint [0] - this.touchCord [0];

			if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > 20) {
				this.scroll(deltaY > 0? -1 : 1);
				if (typeof event.cancelable !== 'boolean' || event.cancelable) {
					event.preventDefault();
				}
			}
			this.touchCord = [0, 0];
		},

		// change the visible slice
		scroll: function(dir) {
			if (typeof dir === "undefined") {
				dir = this.autoscrollDir;
			}
			this.slice = Math.max(0, Math.min(this.maxSlice, this.slice + dir * this.scrollBy));
		},

		// automatic timer based scrolling
		autoscroll: function(op, dir) {
			this.autoscrollDir = dir;
			if (this.autoscrollHandle != null) {
				clearInterval(this.autoscrollHandle);
				this.autoscrollHandle = null;
			}
			if (op == "start") {
				this.autoscrollHandle = setInterval(this.scroll, 200);
			}
		}
	}
}